<template>
  <div class="legal-texts-show-layout">
    <loader v-if="isLoading" />
    <div v-if="isSuccessfullyLoaded">
      <h1>{{legalText.name}}</h1>

      <router-view :legal-text="legalText" />
    </div>
  </div>
</template>

<script>
import View from '@/mixins/View';
import legalTextQuery from '@/api/queries/legal-text.graphql';

export default {
  name: 'legal-texts-show-layout',
  mixins: [View],
  computed: {
    id() {
      return this.$route.params.id;
    },
    breadcrumbs() {
      return [
        {
          key: 'show',
          text: () => this.legalText.name,
          route: { name: 'legal-text', params: { id: this.id } },
          isLoading: !this.isSuccessfullyLoaded,
        },
      ];
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.legalText;
    },
    contractRevisionCount() {
      if (!this.isSuccessfullyLoaded) return null;
      const count = this.legalText.contractRevisions.pagination.totalCount;
      return `(${count})`;
    },
    productRevisionCount() {
      if (!this.isSuccessfullyLoaded) return null;
      const count = this.legalText.productRevisions.pagination.totalCount;
      return `(${count})`;
    },
    productFamilyRevisionCount() {
      if (!this.isSuccessfullyLoaded) return null;
      const count = this.legalText.productFamilyRevisions.pagination.totalCount;
      return `(${count})`;
    },
  },
  apollo: {
    legalText: {
      query: legalTextQuery,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ legalText }) {
        return legalText;
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  i18n: {
    messages: {
      de: {
        showLegalTexts: 'Rechtstext anzeigen',
        showContractRevisions: 'Verträge',
        showProductRevisions: 'Produkte',
        showProductFamilyRevisions: 'Produktfamilien',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ShowLayout.vue?425e45f4